<template>
  <svg aria-hidden="true" class="icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 5.25H8.25" class="cls-1" />
    <path d="M10.5 12.75H3.75" class="cls-1" />
    <path
      d="M12.75 15C13.9926 15 15 13.9926 15 12.75C15 11.5074 13.9926 10.5 12.75 10.5C11.5074 10.5 10.5 11.5074 10.5 12.75C10.5 13.9926 11.5074 15 12.75 15Z"
      class="cls-1"
    />
    <path
      d="M5.25 7.5C6.49264 7.5 7.5 6.49264 7.5 5.25C7.5 4.00736 6.49264 3 5.25 3C4.00736 3 3 4.00736 3 5.25C3 6.49264 4.00736 7.5 5.25 7.5Z"
      class="cls-1"
    />
  </svg>
</template>
<script>
export default {
  name: 'FilterIcon'
}
</script>
<style lang="scss" scoped>
.icon {
  display: inline-block;
}

.cls-1 {
  fill: none;
  stroke: var(--zenith-theme-primary);
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
